/* OLVR ring builder: sideways option rows hold their place (Oct 23, 2026).
   Loaded only on the ring builder (custom liquid block in
   templates/product.builder.json). Remove that script tag to undo.

   Why: picking an option (a shape, a metal, a hidden stone) makes Dawn swap in
   a fresh copy of all the options from the server, and on mobile the builder
   steps are rebuilt too. Both start every sideways row back at the left edge,
   so a shopper who swiped over to Round or Platinum lost sight of their pick.

   What it does: remembers how far each row is scrolled and puts it back after
   any rebuild. If the picked option would still be off screen, the row is
   nudged just enough to show it. Positions are kept for the browser tab
   (sessionStorage), so the collection row also holds its place across the
   page load when a different style is picked. */
(function () {
  if (window.__olvrRows) return;
  window.__olvrRows = true;

  var ROWS = '.swatch-options-wrapper, variant-king-combined-listing ul.swatch-view, .gpo-ov-wrapper.horizontal';
  var STORE = 'olvrRowPos';
  var RECENT_MS = 250; /* KNOB: a row scrolled this recently is being swiped, leave it alone */

  var pos = {};
  try { pos = JSON.parse(sessionStorage.getItem(STORE) || '{}') || {}; } catch (e) { pos = {}; }
  var saveTimer = null;
  function save() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      try { sessionStorage.setItem(STORE, JSON.stringify(pos)); } catch (e) {}
    }, 200);
  }

  /* One name per row that stays the same when the row is replaced. */
  function keyFor(el) {
    var m = String(el.className || '').match(/swatch-options-wrapper__[\w-]+/);
    if (m) return m[0];
    var vk = el.closest('variant-king-combined-listing');
    if (vk) {
      var list = vk.querySelectorAll('ul.swatch-view');
      for (var i = 0; i < list.length; i++) if (list[i] === el) return 'vk-' + i;
    }
    var g = el.closest('.gpo-element');
    if (g) return 'gpo-' + String(g.className).replace(/\s+/g, '.');
    return null;
  }

  function selectedIn(el) {
    var inp = el.querySelector('input:checked');
    if (inp) return inp.closest('label') || (inp.id && el.querySelector('label[for="' + inp.id + '"]')) || inp.parentElement;
    return el.querySelector('li[aria-checked="true"], .swatch-selected, .selected');
  }

  function setLeft(el, x) {
    var prev = el.style.scrollBehavior;
    el.style.scrollBehavior = 'auto'; /* the rows scroll smoothly by default; jump instead */
    el.__olvrSetting = true;
    el.scrollLeft = x;
    setTimeout(function () { el.style.scrollBehavior = prev; el.__olvrSetting = false; }, 60);
  }

  function restore(el) {
    if (!el.offsetParent || el.scrollWidth <= el.clientWidth + 1) return; /* hidden step or nothing to scroll */
    var k = keyFor(el);
    if (!k) return;
    if (el.__olvrScrolledAt && Date.now() - el.__olvrScrolledAt < RECENT_MS) return;
    var want = pos[k];
    /* Oct 25: on desktop a saved spot could be one the row can't reach (the
       row is wider there, or it snaps to the nearest option), so it kept
       trying about 25 times a second and kept the page busy, which stopped the
       builder from re-sorting the options after a pick (the metal and hidden
       stone rows vanished). Aim for the furthest the row can go, and try each
       spot only once per copy of the row. */
    if (typeof want === 'number') {
      var target = Math.max(0, Math.min(want, el.scrollWidth - el.clientWidth));
      if (Math.abs(el.scrollLeft - target) > 2 && el.__olvrTried !== target) {
        el.__olvrTried = target;
        setLeft(el, target);
      }
    }
    /* First time this copy of the row is on screen: make sure the pick shows. */
    if (!el.__olvrSeen) {
      el.__olvrSeen = true;
      var sel = selectedIn(el);
      if (sel) {
        var r = el.getBoundingClientRect(), s = sel.getBoundingClientRect();
        if (s.width && (s.left < r.left || s.right > r.right)) {
          var x = el.scrollLeft + (s.left < r.left ? s.left - r.left - 12 : s.right - r.right + 12);
          setLeft(el, Math.max(0, x));
          pos[k] = Math.max(0, x);
          save();
        }
      }
    }
  }

  var queued = false;
  function restoreAll() {
    if (queued) return;
    queued = true;
    /* setTimeout, not requestAnimationFrame: a frame callback can be held back
       while the tab is busy or in the background, and then nothing restores. */
    setTimeout(function () {
      queued = false;
      document.querySelectorAll(ROWS).forEach(restore);
    }, 16);
  }

  /* After the swap Dawn puts focus back on the option that was picked
     (assets/product-info.js renderProductInfo), and focusing scrolls the row to
     wherever that hidden radio button sits. Inside these rows, focus without
     scrolling. */
  var nativeFocus = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function (opts) {
    if (this.closest && this.closest(ROWS)) {
      var o = {};
      if (opts) for (var p in opts) o[p] = opts[p];
      o.preventScroll = true;
      return nativeFocus.call(this, o);
    }
    return nativeFocus.apply(this, arguments);
  };

  /* Remember positions as the shopper swipes. */
  document.addEventListener('scroll', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches(ROWS) || el.__olvrSetting) return;
    var k = keyFor(el);
    if (!k) return;
    el.__olvrScrolledAt = Date.now();
    pos[k] = el.scrollLeft;
    save();
  }, true);

  /* Any rebuild of the options (Dawn's swap, the mobile step rebuild, Next and
     Back) shows up here. */
  function start() {
    var root = document.querySelector('.product__info-container') || document.body;
    new MutationObserver(function (records) {
      /* ignore the style changes this file makes itself */
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type !== 'attributes' || !(r.target && r.target.__olvrSetting)) { restoreAll(); return; }
      }
    }).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    restoreAll();
    window.addEventListener('load', restoreAll);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
